import * as React from 'react';
import { v4 } from 'uuid';
import { FixMeLater } from '../../utils';

export type CloneProps = {
    /**
     * The child component to duplicate.
     */
    children?: React.ReactElement<any>;

    /**
     * A function to render the child components.
     */
    renderChildren?: (index: number) => React.JSX.Element;

    /**
     * The number of copies to be generated.
     */
    copies: number;

    /**
     * Ref to be passed to each cloned child.
     */
    ref?: React.Ref<FixMeLater>;
};

export function Clone(props: Readonly<CloneProps>): React.JSX.Element {
    const { copies, children, ref, renderChildren } = props;
    const keyArray = React.useRef(
        Array(copies)
            .fill(0)
            .map((_) => v4())
    );

    return (
        <>
            {Array(copies)
                .fill(0)
                .reduce((acc, _, index) => {
                    if (renderChildren) {
                        return [
                            ...acc,
                            React.cloneElement(renderChildren(index), {
                                key: keyArray.current[index],
                                ref,
                            }),
                        ];
                    }
                    if (children) {
                        return [
                            ...acc,
                            React.cloneElement(children, {
                                key: keyArray.current[index],
                                ref,
                            }),
                        ];
                    }
                    return acc;
                }, [])}
        </>
    );
}
